import { Video } from './Video';

export type { TypeVideoProps } from './types';
export default Video;
